import * as $ from 'jquery';
import 'jquery-colorbox';
 
// settings for Experts Youtube video popup
$('#experts-video a').colorbox({
	iframe: true,
	transition: 'none',
	width: '1200',
    height: '740',
	maxWidth: '85%',
	maxHeight: '85%',
	fixed: true,
	reposition: true,
});

// Need for colorbox resizing
$(window).resize(function(){
    var cboxOptions = {
        width: '640',
        height: '390',
        maxWidth: '85%',
        maxHeight: '70%%',
    }
    $.colorbox.resize({
        width: window.innerWidth > parseInt(cboxOptions.maxWidth) ? cboxOptions.maxWidth : cboxOptions.width,
        height: window.innerHeight > parseInt(cboxOptions.maxHeight) ? cboxOptions.maxHeight : cboxOptions.height
    });
});